export default {
  billingData: null,
  status: '',
  bankAccount: {}
};
